/*
 * Browser helper for calling our own API routes. Adds the CSRF header every
 * write needs (see lib/api.ts) and turns any failure into a plain message.
 */

export type ApiResult<T> =
    | { ok: true, data: T }
    | { ok: false, status: number, message: string }

type ApiOptions = {
    method?: string
    body?: unknown
    raw?: Blob
    headers?: Record<string, string>
}

const FALLBACK = 'Terjadi gangguan koneksi. Coba lagi sebentar lagi.'

export async function apiFetch<T>(url: string, options: ApiOptions = {}): Promise<ApiResult<T>> {
    try {
        const response = await fetch(url, {
            method: options.method ?? (options.body === undefined && !options.raw ? 'GET' : 'POST'),
            credentials: 'same-origin',
            headers: {
                'X-Requested-With': 'hajime',
                ...(options.raw ? {} : { 'Content-Type': 'application/json' }),
                ...options.headers
            },
            body: options.raw ?? (options.body === undefined ? undefined : JSON.stringify(options.body))
        })

        const data = await response.json().catch(() => null) as (T & { message?: string }) | null

        if (!response.ok) return { ok: false, status: response.status, message: data?.message || FALLBACK }

        return { ok: true, data: data as T }
    }
    catch {
        return { ok: false, status: 0, message: FALLBACK }
    }
}
